export default function PHP_set_charset() {
  return (
    <div>
      <h1>PHP_set_charset</h1>
    </div>
  );
}
